import {
  SURVEY_OF_OWNER_FAIL,
  SURVEY_OF_OWNER_REQUEST,
  SURVEY_OF_OWNER_SUCCESS,
  SURVEY_OF_OWNER_CLEAR_ERRORS,
  SURVEY_REQUEST,
  SURVEY_SUCCESS,
  SURVEY_FAIL,
  SURVEY_CLEAR_ERRORS,
  SURVEY_OF_OWNER_ASSIGN_TO_USER_CLEAR_ERRORS,
  SURVEY_OF_OWNER_ASSIGN_TO_USER_FAIL,
  SURVEY_OF_OWNER_ASSIGN_TO_USER_REQUEST,
  SURVEY_OF_OWNER_ASSIGN_TO_USER_SUCCESS,
  SURVEY_ASSIGN_BY_SURVEY_ID_REQUEST,
  SURVEY_ASSIGN_BY_SURVEY_ID_SUCCESS,
  SURVEY_ASSIGN_BY_SURVEY_ID_FAIL,
  SURVEY_ASSIGN_BY_SURVEY_ID_CLEAR_ERRORS,
  //Submission check
  SURVEY_ANS_SUBMIT_CLEAR_ERRORS,
  SURVEY_ANS_SUBMIT_FAIL,
  SURVEY_ANS_SUBMIT_REQUEST,
  SURVEY_ANS_SUBMIT_SUCCESS,
} from "../Constants/owner_surveys_constants";

export const owner_surveys_reducer = (
  state = {
    owner_surveys: [],
  },
  action
) => {
  switch (action.type) {
    case SURVEY_OF_OWNER_REQUEST:
      return {
        owner_surveys_loading: true,
        owner_surveys: [],
      };
    case SURVEY_OF_OWNER_SUCCESS:
      return {
        owner_surveys_loading: false,
        owner_surveys: action.payload.data.result,
      };
    case SURVEY_OF_OWNER_FAIL:
      return {
        owner_surveys_loading: false,
        owner_surveys: null,
        owner_surveys_error: action.payload,
      };

    case SURVEY_OF_OWNER_CLEAR_ERRORS:
      return {
        ...state,
        owner_surveys_error: null,
      };
    default:
      return state;
  }
};

export const owner_surveys_actions_reducer = (
  state = {
    owner_surveys_actions: [],
  },
  action
) => {
  switch (action.type) {
    case SURVEY_REQUEST:
      return {
        owner_surveys_actions_loading: true,
        owner_surveys_actions: [],
      };
    case SURVEY_SUCCESS:
      return {
        owner_surveys_actions_loading: false,
        owner_surveys_actions: action.payload.data,
      };
    case SURVEY_FAIL:
      return {
        owner_surveys_actions_loading: false,
        owner_surveys_actions: null,
        owner_surveys_actions_error: action.payload,
      };

    case SURVEY_CLEAR_ERRORS:
      return {
        ...state,
        owner_surveys_actions_error: null,
      };
    default:
      return state;
  }
};

// Reducer of Survey assign to user all List

export const owner_survey_assign_to_user_reducer = (
  state = {
    owner_survey_assign_to_user: [],
  },
  action
) => {
  switch (action.type) {
    case SURVEY_OF_OWNER_ASSIGN_TO_USER_REQUEST:
      return {
        loading_survey_assign_to_user: true,
        owner_survey_assign_to_user: [],
      };
    case SURVEY_OF_OWNER_ASSIGN_TO_USER_SUCCESS:
      return {
        loading_survey_assign_to_user: false,
        owner_survey_assign_to_user: action.payload,
      };
    case SURVEY_OF_OWNER_ASSIGN_TO_USER_FAIL:
      return {
        loading_survey_assign_to_user: false,
        owner_survey_assign_to_user: null,
        survey_assign_to_user_error: action.payload,
      };
    case SURVEY_OF_OWNER_ASSIGN_TO_USER_CLEAR_ERRORS:
      return {
        ...state,
        survey_assign_to_user_error: null,
      };
    default:
      return state;
  }
};

/// get assign by survey id to update

export const owner_survey_assign_by_survey_id_reducer = (
  state = {
    owner_survey_assign_by_survey_id: [],
  },
  action
) => {
  switch (action.type) {
    case SURVEY_ASSIGN_BY_SURVEY_ID_REQUEST:
      return {
        owner_survey_assign_by_survey_id_loading: true,
        owner_survey_assign_by_survey_id: [],
      };
    case SURVEY_ASSIGN_BY_SURVEY_ID_SUCCESS:
      return {
        owner_survey_assign_by_survey_id_loading: false,
        owner_survey_assign_by_survey_id: action.payload,
      };
    case SURVEY_ASSIGN_BY_SURVEY_ID_FAIL:
      return {
        owner_survey_assign_by_survey_id_loading: false,
        owner_survey_assign_by_survey_id: null,
        owner_survey_assign_by_survey_id_error: action.payload,
      };

    case SURVEY_ASSIGN_BY_SURVEY_ID_CLEAR_ERRORS:
      return {
        ...state,
        owner_survey_assign_by_survey_id_error: null,
      };
    default:
      return state;
  }
};
// survey submitted

export const ans_sub_state_reducer = (
  state = {
    ans_sub_state: [],
  },
  action
) => {
  switch (action.type) {
    case SURVEY_ANS_SUBMIT_REQUEST:
      return {
        ans_sub_state_loading: true,
        ans_sub_state: [],
      };
    case SURVEY_ANS_SUBMIT_SUCCESS:
      return {
        ans_sub_state_loading: false,
        ans_sub_state: action.payload.data,
      };
    case SURVEY_ANS_SUBMIT_FAIL:
      return {
        ans_sub_state_loading: false,
        ans_sub_state: null,
        ans_sub_state_error: action.payload,
      };

    case SURVEY_ANS_SUBMIT_CLEAR_ERRORS:
      return {
        ...state,
        ans_sub_state_error: null,
      };
    default:
      return state;
  }
};
